import { memo } from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * Splits text into lines based on the entity's newline character.
 * @param {object} textEntity - The text entity containing displayText and newLineChar
 * @returns {string[]} Array of text lines
 */
const getTextLines = (textEntity) => {
    if (!textEntity?.displayText) return []
    const escapedNewLineChar = textEntity.newLineChar.toString().replace('\\', '\\\\')
    const newLineCharLower = escapedNewLineChar.toLowerCase()
    const newLineCharUpper = escapedNewLineChar.toUpperCase()
    const regex = new RegExp(`[${newLineCharLower}|${newLineCharUpper}]+`)
    return textEntity.displayText.split(regex)
}

const TextRenderer = ({ hidden = false, onClick, path, sx, textEntity, usingCartesianCoordinates }) => {
    // Derived value - no need for useState/useEffect since this is a pure transformation
    const textLines = getTextLines(textEntity)

    return (
        textEntity &&
        !hidden && (
            <Box
                component="text"
                hidden={hidden}
                id={path.pathId}
                sx={sx}
                transform={usingCartesianCoordinates ? `matrix(1,0,0-1,0,${2 * textEntity.bottomLeft.y})` : null}
                translate="no"
                x={textEntity.bottomLeft.x}
                y={textEntity.bottomLeft.y}
                onClick={onClick}
            >
                {textLines.map((textLine, index) => (
                    <tspan
                        dy={index > 0 ? '1.2em' : 0}
                        key={index}
                        x={textEntity.bottomLeft.x}
                    >
                        {textLine}
                    </tspan>
                ))}
            </Box>
        )
    )
}

TextRenderer.propTypes = {
    hidden: PropTypes.bool,
    path: PropTypes.object,
    sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])),
        PropTypes.func,
        PropTypes.object,
    ]),
    textEntity: PropTypes.object,
    usingCartesianCoordinates: PropTypes.bool,
    onClick: PropTypes.func,
}

export default memo(TextRenderer)
